import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { routes } from '@/routes';
import { selectAccount, selectIsAdmin } from '@/store/selectors';
import { logout } from '@/store/slices/accountSlice';
import { useCallback, useMemo } from 'react';

type TMenuItem = { label: string, link: string }

type TUseMenu = {
    menu: TMenuItem[]
    accountLink: string | undefined
    onClickLogout: () => void
}

export const useMenu = (): TUseMenu => {
    const account = useAppSelector(selectAccount);
    const isAdmin = useAppSelector(selectIsAdmin);

    const dispatch = useAppDispatch();

    const onClickLogout = useCallback(() => {
        dispatch(logout());
    }, [dispatch]);

    const accountLink = useMemo<string | undefined>(() => {
        return account ? routes.users + '/' + account.id : undefined;
    }, [account]);

    const menu = useMemo<TMenuItem[]>(() => {
        const menu: TMenuItem[] = [
            { label: 'События', link: routes.app },
            { label: 'Рассылки', link: routes.sendList },
            { label: 'Архивы', link: routes.archive },
            { label: 'ЮР лицам', link: routes.company },
        ];
        if (isAdmin) {
            menu.push({ label: 'Пользователи', link: routes.users });
        }
        return menu;
    }, [isAdmin]);

    return {
        menu,
        accountLink,
        onClickLogout,
    };
};
